import React, { useState } from "react"
import Highlight, { defaultProps } from "prism-react-renderer"
import { LiveProvider, LiveEditor, LivePreview, LiveError } from "react-live"
import theme from "prism-react-renderer/themes/dracula"
import { CopyToClipboard } from "react-copy-to-clipboard"
import { Transition } from "semantic-ui-react"
import { ResizableBox } from 'react-resizable';
import {ContainerQuery} from 'react-container-query';
import classnames from 'classnames';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics'

import Select from 'react-select';

import "./codeblock.scss"


export default ({ children, className, live, tabbed, codeProv, options, defaultSate, defaultCSS, defaultModifiers}) => {
  const [copyStatus, setCopyStatus] = useState(false)
  const [codeVisibility, setCodeVisibility] = useState(false)


  const copyCode = () => {
    setCopyStatus(true)
    setTimeout(() => setCopyStatus(false), 3000)
  }

  const showCode = e => {
    trackCustomEvent({
      category: "Codeblock",
      action: "Click",
      label: "Code Copied",
    })
    setCodeVisibility(!codeVisibility)
    setTimeout(() => setCodeVisibility(codeVisibility), 3000)
  }

  const query = {
    'mobile-width': {
      minWidth: 200,
      maxWidth: 344
    },
    'tablet-width': {
      minWidth: 345,
      maxWidth: 768
    }
  };


const componentSizes = "TBC"


//  NEW

const [selectedValue, setSelectedValue] = useState(defaultSate);
const [selectedModifiers, setSelectedModifers] = useState(defaultModifiers)
const [selectedCSS, setSelectedCSS] = useState(defaultCSS)


const handleChange = e => {
  setSelectedValue(e.codeField);
  setSelectedModifers(e.modifiers)
  setSelectedCSS(e.css)
}

const handleRadioChange = e =>
{
  setSelectedValue(e.target.value) 
}





  const language = className && className.replace(/language-/, "")

  if (codeProv) {
    return (
   <>

<Select
         className="slDrp"
          placeholder="Select Option"
          value={options.filter(obj => obj.codeField === selectedValue)}
          onChange={handleChange}
          options={options}
        />


<div className="codeProvider">
<LiveProvider code={selectedValue} theme={theme}>      
<div className="prevCust" >
  <LivePreview className="lprev"/>
  <div className="rightBar">
<div className="customCont">Customise</div>
  <div className="modifiers">
    Modifiers
{selectedModifiers.map((modifiers, index) => {
  return (
    <div key={index}>
    {Object.keys(modifiers).map((key) => {
    return (
      <div>
      <input  type="radio" key={key + index} id={key} name={index} value={modifiers[key]} onClick={handleRadioChange} />
      <label htmlFor={key}>{key}</label>
      </div>
    )
    })}
    </div>
  )
})}

  </div>
  <div className="sizes">
    {componentSizes}
  </div>
</div>
</div> {/* End of Prev Cust */}
  <div className="style--prov-PW">
    <div className="style--prov-CT">
        <div className="style--prov-over">
          {selectedCSS}
        </div>
    </div>
  </div>
  <LiveEditor />
</LiveProvider>
</div>





   </>
    )
  }





  if (live) {
    return (
      <div className="docs codeblock">
        <div className="docs responsiveArea"><span className="mob">Mobile</span><span className="tabdesk">Tablet/Desktop</span></div>
        <LiveProvider code={children} theme={theme}>
        <ResizableBox className="box" width={768} height={Infinity} axis="x" draggableOpts={{grid: [16]}} minConstraints={[344]}maxConstraints={[768]}>
          <div className="html docs top livexample">
          <ContainerQuery query={query}>
          {(params) => (
          <div id="Test" className={classnames(params)}><LivePreview /></div>
          )}
          </ContainerQuery> 
          </div>
          </ResizableBox>
            <div className="docs instructive bottom attached segment">
              <LiveEditor />
            </div>
            <LiveError />
        </LiveProvider>
        <div className="docs codecopy">
        <CopyToClipboard text={children} onCopy={copyCode}>
            <button onClick={showCode} className="nBtn button">{`${codeVisibility ? "Code Copied" : "Copy Code"}`}</button>
          </CopyToClipboard>
            </div>

      </div>
    )
  }

  if (tabbed) {
    return (
      <div className="docs codeblock">
              <h1>Testing</h1>
        <div className="docs responsiveArea"><span className="mob">Mobile</span><span className="tabdesk">Tablet/Desktop</span></div>
        <LiveProvider language={"html"} code={children} theme={theme}>
        <ResizableBox className="box" width={768} height={Infinity} axis="x" draggableOpts={{grid: [16]}} minConstraints={[344]}maxConstraints={[768]}>
          <div className="html docs top livexample">
          <ContainerQuery query={query}>
          {(params) => (
          <div className={classnames(params)}><LivePreview /></div>
          )}
          </ContainerQuery> 
          </div>
          </ResizableBox>
          <Transition visible={codeVisibility} animation="fade" duration={500}>
            <div className="docs instructive bottom attached segment">
              <LiveEditor />
            </div>
          </Transition>
        </LiveProvider>
        <div className="docs codecopy">
        <CopyToClipboard text={children} onCopy={copyCode}>
            <button onClick={showCode} className="nBtn button">{`${codeVisibility ? "Code Copied" : "Copy Code"}`}</button>
        </CopyToClipboard>
            </div>
      </div>
    )
  }

  return (
    <Highlight
      {...defaultProps}
      code={children}
      language={language}
      theme={theme}
    >
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <pre className={className} style={{ ...style, padding: "24px" }}>
          {tokens.map((line, i) => (
            <div key={i} {...getLineProps({ line, key: i })}>
              {line.map((token, key) => (
                <span key={key} {...getTokenProps({ token, key })} />
              ))}
            </div>
          ))}
        </pre>
      )}
    </Highlight>
    
  )
}